module.exports = __webpack_public_path__ + "static/media/spain.bcbebdc0.jpg";